/**
 * The CRM install a deal stages tab write names (#2118, #2139) — shared by the
 * domain clients whose writes are keyed by the CRM's own pipeline and stage
 * ids (sales methodology, stage phases, exact stage bindings).
 */

import { CRM_INSTALLATION_CHANGED_CODE } from '@aica/api-types/schemas';

/** A write URL with the install whose pipelines the tab shows, when known. */
export const withInstallation = (path: string, installationId?: string) =>
  installationId === undefined
    ? path
    : `${path}?installationId=${encodeURIComponent(installationId)}`;

/**
 * A request from a tab that still shows another CRM's pipelines: the tab reads
 * them again — an answer, not a failure.
 */
export const INSTALLATION_CHANGED_REFUSALS = [
  { status: 409, code: CRM_INSTALLATION_CHANGED_CODE },
] as const;
